/* =============================================
   FLORIACH ARCHIVES — Custom JS
   Logo color change + Category bar visibility
   Tema: Label 3.6.1 (Switch Themes)
   ============================================= */

document.addEventListener('DOMContentLoaded', function() {

  // ---- CONFIGURACIÓN ----
  var SCROLL_THRESHOLD = 100;

  // Selectores del logo
  var LOGO_SELECTORS = [
    '.header__logo img',
    '.header .logo img',
    '.site-header__logo img',
    '[data-header-logo] img',
    '.header__heading-link img',
    'a.header__logo img'
  ];

  // Selectores del header
  var HEADER_SELECTORS = [
    '.header',
    '.site-header',
    '#shopify-section-header',
    '[data-header]'
  ];

  // ---- ENCONTRAR ELEMENTOS ----
  var logoEl = null;
  var headerEl = null;
  var categoryBar = document.getElementById('floriach-category-bar');

  for (var i = 0; i < LOGO_SELECTORS.length; i++) {
    logoEl = document.querySelector(LOGO_SELECTORS[i]);
    if (logoEl) break;
  }

  for (var j = 0; j < HEADER_SELECTORS.length; j++) {
    headerEl = document.querySelector(HEADER_SELECTORS[j]);
    if (headerEl) break;
  }

  // ---- SCROLL HANDLER ----
  var ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(function() {
        var scrollY = window.scrollY || window.pageYOffset;

        // Logo: invertir colores al hacer scroll
        if (logoEl) {
          if (scrollY > SCROLL_THRESHOLD) {
            logoEl.style.filter = 'invert(1)';
            logoEl.style.transition = 'filter 0.3s ease';
          } else {
            logoEl.style.filter = 'invert(0)';
            logoEl.style.transition = 'filter 0.3s ease';
          }
        }

        // Barra de categorías: mostrar al hacer scroll, pegada arriba
        if (categoryBar) {
          if (scrollY > SCROLL_THRESHOLD) {
            categoryBar.classList.add('is-visible');
            categoryBar.classList.remove('below-header');
          } else {
            categoryBar.classList.remove('is-visible');
          }
        }

        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Ejecutar al cargar
  onScroll();


  // ---- FECHA DE ENTREGA ESTIMADA (solo en página de producto) ----
  // Regla: los pedidos hechos en día laborable antes de las 13:00 salen ese día;
  // el resto sale el siguiente día laborable. La entrega es 2 días laborables después del envío.
  if (document.body.classList.contains('template-product') || document.querySelector('.product-form')) {

    var HORA_CORTE = 13;
    var DIAS_ENTREGA = 2;

    function esLaborable(fecha) {
      var d = fecha.getDay();
      return d !== 0 && d !== 6;
    }

    function sumarLaborables(fecha, n) {
      var r = new Date(fecha);
      while (n > 0) {
        r.setDate(r.getDate() + 1);
        if (esLaborable(r)) n--;
      }
      return r;
    }

    function calcularFechaEntrega() {
      var ahora = new Date();
      var envio = new Date(ahora);
      if (!esLaborable(envio) || ahora.getHours() >= HORA_CORTE) {
        envio = sumarLaborables(envio, 1);
      }
      var entrega = sumarLaborables(envio, DIAS_ENTREGA);

      var dias = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
      var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

      return dias[entrega.getDay()] + ', ' + entrega.getDate() + ' ' + meses[entrega.getMonth()];
    }

    // Insertar después del botón de añadir al carrito
    var formProducto = document.querySelector('.product-form form, .product-form, form[action*="/cart/add"]');
    if (formProducto) {
      var deliveryDiv = document.createElement('div');
      deliveryDiv.className = 'floriach-delivery-date';
      deliveryDiv.innerHTML = '<i aria-hidden="true" style="display:inline-block;width:8px;height:8px;min-width:8px;border-radius:50%;background:#8fd0a8;margin-right:4px;"></i><span>Compra ahora recíbelo el <strong style="color:#000;font-weight:700;">' + calcularFechaEntrega() + '</strong>.</span>';

      // Insertar después del formulario o después del botón de pago
      var paymentButton = document.querySelector('.shopify-payment-button');
      if (paymentButton) {
        paymentButton.parentNode.insertBefore(deliveryDiv, paymentButton.nextSibling);
      } else {
        formProducto.parentNode.insertBefore(deliveryDiv, formProducto.nextSibling);
      }
    }
  }

});
